// extracted by mini-css-extract-plugin
module.exports = {"container":"postcode-search_container__4a_yG","searchContainer":"postcode-search_searchContainer__UwK_2","searchButton":"postcode-search_searchButton__yFAZs"};